import { Button } from '@crazyegginc/hatch';

import { Paywall } from '/src/components/Paywall';
import { useFunnelEditorContext } from '../../funnel-editor-context';
import { usePermissions } from '/src/hooks';
import { FEATURES } from '/src/features/_global/constants';

import FunnelsPNG from '@crazyegginc/hatch/dist/images/illustration-funnels2.png';
import FunnelsWebP from '@crazyegginc/hatch/dist/images/illustration-funnels2.webp';

import { ReactComponent as PlusIcon } from '@crazyegginc/hatch/dist/images/icon-plus.svg';

export function AddStepWall() {
  const { activateAddStep } = useFunnelEditorContext();
  const permissions = usePermissions();
  const canEditFunnel = permissions.can('edit', FEATURES.FUNNELS).allowed;

  return (
    <div className="flex-1 justify-center flex mt-28">
      <Paywall>
        <Paywall.Image webp={FunnelsWebP} fallback={FunnelsPNG} width="253px" />
        <Paywall.Title>Add a Step to Create Your Funnel!</Paywall.Title>

        <Paywall.Body>
          <p className="max-w-md">
            Find out where your users are dropping off or converting most throughout your site. This will help you
            pinpoint areas to improve and boost conversions.
          </p>
        </Paywall.Body>

        <Button disabled={!canEditFunnel} onClick={activateAddStep}>
          <PlusIcon className="mr-2 h-2.5 w-2.5 fill-current" />
          Add Step
        </Button>
      </Paywall>
    </div>
  );
}
